import React, { useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { ProgramContainer, StyledTypography } from './styles';
import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import LabelTitle from '../../../../components/Titles/LabelTitle';
import { InscriptionButton } from '../../../../components/Buttons';
import Animation from '../../../../components/Animation';
import { scrollToProgramSelector } from '../../selectors';
import ProgramList from './List';

const Program = props => {
	const { t } = useTranslation();
	const ref = useRef(null);

	useEffect(() => {
		if (props.scrollToProgram) {
			ref.current.scrollIntoView({
				behavior: 'smooth',
				block: 'start'
			});
		}
	}, [props.scrollToProgram]);

	return (
		<ProgramContainer ref={ref}>
			<Animation animateIn="fadeInDown">
				<LabelTitle content={t('general.program.label')} />
				<StyledTypography variant="h2" color="textSecondary">
					{t('general.program.title')}
				</StyledTypography>
				<Box mt={5} display={{ xs: 'none', sm: 'block' }}>
					<InscriptionButton />
				</Box>
			</Animation>
			<ProgramList />
		</ProgramContainer>
	);
};

const mapStateToProps = state => {
	return {
		scrollToProgram: scrollToProgramSelector(state)
	};
};

const mapDispatchToProps = dispatch => {
	return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Program);
